import React from "react";

import { BlockViews } from "@jelly/lesson";

import defaultStyle from "./AudioBlockView.module.scss";

const CoreAudioBlock = BlockViews.audio;

type AudioBlockViewProps = React.ComponentProps<typeof CoreAudioBlock> & {
  text?: string;
  reverse?: boolean;
};

export const AudioBlockView: React.FC<AudioBlockViewProps> = (props) => {
  // @ts-expect-error `classNames` props is not exposed even though it's available
  return <CoreAudioBlock {...props} classNames={defaultStyle} />;
};
